import { Box, Typography, useMediaQuery } from "@mui/material";
import { green, grey, red, blue } from "@mui/material/colors";

export function EquipmentLayoutPreview({ layout, produtos = {}, titulo, compacto = false }) {
    const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'));

    const CORES = {
        livre: { bg: green[200], bd: green[400], fg: green[900] },
        ocupado: { bg: green[700], bd: green[900], fg: '#fff' },
        bloqueado: { bg: red[700], bd: red[900], fg: '#fff' },
        inativo: { bg: red[700], bd: red[900], fg: '#fff' },
        agrupado: { bg: grey[400], bd: grey[500], fg: grey[900] },
        agrupadoMaquina: { bg: grey[400], bd: grey[500], fg: grey[900] },
    };

    const LEGEND_MAQUINA = [
        { label: 'Motor Livre', bg: green[200], bd: green[400] },
        { label: 'Motor Ocupado', bg: green[700], bd: green[900] },
        { label: 'Motor Agrupado', bg: grey[400], bd: grey[500] },
        { label: 'Motor Bloqueado', bg: red[700], bd: red[900] },
    ];

    const LEGEND_ARMARIO = [
        { label: 'Porta Livre', bg: green[200], bd: green[400] },
        { label: 'Porta Ocupada', bg: green[700], bd: green[900] },
        { label: 'Porta Agrupada', bg: grey[400], bd: grey[500] },
    ];

    if (!layout || layout.slots.length === 0) {
        return (
            <Box sx={{ py: 3, textAlign: 'center' }}>
                <Typography variant="body2" color="text.secondary">
                    Sem configuração para exibir.
                </Typography>
            </Box>
        );
    }

    const { tipo, cols, slots } = layout;
    const isArmario = tipo === 'armario';

    const sz = compacto ? (isSmall ? 26 : 32) : (isSmall ? 36 : 48);
    const gap = compacto ? 5 : 8;

    const maxRow = Math.max(...slots.map(s => s.gridRow + (s.rowSpan - 1)));
    const legenda = isArmario ? LEGEND_ARMARIO : LEGEND_MAQUINA;

    const corDoSlot = (slot) => {
        if (slot.agrupado) {
            return isArmario ? CORES.agrupado : CORES.agrupadoMaquina;
        }

        if (slot.idProduto) return CORES.ocupado;
        return CORES[slot.status] ?? CORES.livre;
    };

    const rotulo = (slot) => {
        if (!isArmario && slot.agrupado && slot.numeroPar) {
            return `${slot.numero} + ${slot.numeroPar}`;
        }
        return slot.numero;
    };

    return (
        <Box>
            {titulo && (
                <Typography variant="subtitle2" align="center" sx={{ mb: 1, color: grey[700] }}>
                    {titulo}
                </Typography>
            )}

            <Box sx={{ border: `1px solid ${grey[300]}`, borderRadius: 2, p: compacto ? 1 : 2 }}>
                <Box sx={{
                    display: 'grid',
                    gridTemplateColumns: `repeat(${cols}, ${sz}px)`,
                    gridTemplateRows: `repeat(${maxRow}, ${sz}px)`,
                    gap: `${gap}px`,
                    justifyContent: 'center',
                }}>
                    {slots.map((slot) => {
                        const c = corDoSlot(slot);
                        const w = slot.colSpan * sz + (slot.colSpan - 1) * gap;
                        const h = slot.rowSpan * sz + (slot.rowSpan - 1) * gap;
                        // const nomeProduto = slot.idProduto ? (produtos[slot.idProduto] ?? `Produto ${slot.idProduto}`) : null;
                        const nomeProduto = '';

                        return (
                            <Box
                                key={`${slot.gridRow}-${slot.gridCol}-${slot.numero}`}
                                title={nomeProduto ? `${rotulo(slot)} · ${nomeProduto}${slot.qtd ? ` (${slot.qtd})` : ''}` : `${rotulo(slot)}`}
                                sx={{
                                    gridColumn: `${slot.gridCol} / span ${slot.colSpan}`,
                                    gridRow: `${slot.gridRow} / span ${slot.rowSpan}`,
                                    width: `${w}px`, height: `${h}px`,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor: c.bg,
                                    border: `1.5px solid ${c.bd}`,
                                    color: c.fg,
                                    borderRadius: 1.5,
                                    fontSize: compacto ? 10 : 12,
                                    fontWeight: 500,
                                    overflow: 'hidden',
                                    px: 0.25,
                                }}
                            >
                                <span>{rotulo(slot)}</span>
                                {!compacto && nomeProduto && (
                                    <Typography
                                        variant="caption"
                                        noWrap
                                        sx={{ fontSize: 9, maxWidth: '100%', lineHeight: 1.1 }}
                                    >
                                        {nomeProduto}
                                    </Typography>
                                )}
                            </Box>
                        );
                    })}
                </Box>
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: 1.5, mt: 1 }}>
                {legenda.map(l => (
                    <Box key={l.label} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <Box sx={{ width: 12, height: 12, borderRadius: '3px', backgroundColor: l.bg, border: `1.5px solid ${l.bd}` }} />
                        <Typography variant="caption" color="text.secondary">{l.label}</Typography>
                    </Box>
                ))}
            </Box>
        </Box>
    );
}